module.exports = __webpack_public_path__ + "img/shuiba.10d53cbb.png";